import { List } from "antd";
import { useAuth } from "global/context/AuthenticationContext";

const formatNotificationTime = (value?: string) => {
  if (!value) return "";
  const date = new Date(value);
  return Number.isNaN(date.getTime()) ? "" : date.toLocaleString("vi-VN");
};

function NotificationDropdown() {
  const { listNoti, notiLoading } = useAuth();

  return (
    <div className="w-[300px] md:w-[450px] bg-white border border-[#eee] rounded-lg shadow-md">
      <List
        size="small"
        bordered={false}
        loading={notiLoading}
        dataSource={listNoti}
        style={{
          maxHeight: 500,
          overflowY: "auto",
        }}
        className="scrollbar-hide"
        renderItem={(item: any) => (
          <div className="p-2">
            <div className="min-h-[88px] border border-[#eee] rounded-lg shadow-lg px-1">
              <List.Item
                style={{ flexDirection: "column", alignItems: "flex-start" }}
              >
                <div className="text-[14px] font-semibold">{item.title}</div>
                <div className="w-full break-words text-[13px] font-light">
                  {item.message}
                </div>
                <div className="mt-1 w-full text-right text-[11px] text-[#8c8c8c]">
                  {formatNotificationTime(item.created_at || item.createdAt)}
                </div>
              </List.Item>
            </div>
          </div>
        )}
      />
    </div>
  );
}

export default NotificationDropdown;
